import { render } from "./MyGamesPage.vue?vue&type=template&id=3fdfb676&scoped=true"
import script from "./MyGamesPage.vue?vue&type=script&lang=js"
export * from "./MyGamesPage.vue?vue&type=script&lang=js"

import "./MyGamesPage.vue?vue&type=style&index=0&id=3fdfb676&scoped=true&lang=css"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdfb676"]])

export default __exports__